module.exports = __webpack_public_path__ + "img/cc.06406e05.webp";